// import "@/registerServiceWorker";

import Vue from "vue";

import App from "@/App.vue";
import HeadMetadata from "@/components/HeadMetadata.vue";
import vuetify from "@/plugins/vuetify";
import router from "@/router";
import { ApiService, LogService, RouterService, SearchService, SnackbarService } from "@/services";
import store from "@/store";

LogService._initialize();
SnackbarService._initialize();
ApiService._initialize();
RouterService._initialize();
SearchService._initialize();
LogService.debug("Vignette services initialized.");

Vue.component("HeadMetadata", HeadMetadata);

LogService.debug("Starting Vue app.");
new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
LogService.debug("Vue app started.");
